import Feedbacker from '@/components/Feedbacker/feedbacker.example';

export default Feedbacker;
